import { useRef, useState } from "react";
import { RiArrowDownSLine } from "react-icons/ri";
import { useOnClickOutSide } from "../../tools/hooks/click-outSide-handler";

interface VehiclePelakDropDownProps {
  list?: any;
  value: any;
  setValue: any;
  name: string;
  ReadOnly?: boolean;
  maxLength?: number;
  placeholder?: string;
}

const VehiclePelakDropDown = ({
  list = [],
  value,
  name,
  setValue,
  ReadOnly,
  maxLength,
  placeholder,
}: VehiclePelakDropDownProps) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const WrapperRef = useRef(null);
  useOnClickOutSide(WrapperRef, open, setOpen);

  const handleClick = (vl: any) => {
    setOpen(false);
    setValue(name, vl);
  };

  const handleChange = (e: any) => {
    setValue(name, e.target.value);
    setSearch(e.target.value);
  };

  const listFilter = () => list.filter((l) => l.includes(search));

  return (
    <div className="relative flex-start-center w-[25%]">
      <RiArrowDownSLine size={17} className="cursor-pointer" />
      <div ref={WrapperRef}>
        <input
          autoComplete="off"
          disabled={ReadOnly}
          className=" w-8 text-center focus:outline-none"
          name="ffa"
          maxLength={maxLength}
          onFocus={() => setOpen(true)}
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
        />
        {open && (
          <ul className="absolute shadow-md z-50 bg-light w-8 top-7 border">
            {/* <SimpleBar style={{ maxHeight: "10rem" }}> */}
            {listFilter().length !== 0 ? (
              listFilter().map((l) => (
                <li
                  key={l}
                  onClick={() => handleClick(l)}
                  className="px-1 py-1 transition-all duration-700 hover:cursor-pointer hover:bg-lightGray text-darkGray text-center"
                >
                  {l}
                </li>
              ))
            ) : (
              <p className="py-3 text-center"> </p>
            )}
            {/* </SimpleBar> */}
          </ul>
        )}
      </div>
    </div>
  );
};

export default VehiclePelakDropDown;
